// import React, { useState, useEffect } from 'react';
// import './ReadPage.css';
// import classroomImage from '../as.avif'; // Substitua pelo caminho da sua imagem
// import blogImage1 from '../as.avif'; // Substitua pelo caminho da sua imagem de blog
// import blogImage2 from '../as.avif'; // Substitua pelo caminho da sua imagem de blog

// const ReadPage = () => {
//   const [fontSize, setFontSize] = useState(16); // Tamanho inicial da fonte em pixels
//   const [isBionic, setIsBionic] = useState(false); // Estado para leitura biônica
//   const [isReading, setIsReading] = useState(false); // Estado para leitura por voz
//   const [voiceSpeed, setVoiceSpeed] = useState(1); // Velocidade da voz (1 = normal)
//   const [voiceGender, setVoiceGender] = useState('female'); // Gênero da voz
//   const [voiceLang, setVoiceLang] = useState('en-US'); // Idioma da voz
//   const [voices, setVoices] = useState([]); // Lista de vozes disponíveis

//   const textContent = `IOTC is a platform that allows educators to create online classes whereby they can store the course materials online; manage assignments, quizzes and exams, monitor due dates, grade results and provide students with feedback all in one place. IOTC is a platform that allows educators to create online classes whereby they can store the course materials online; manage assignments, quizzes and exams, monitor due dates, grade results and provide students with feedback all in one place. IOTC is a platform that allows educators to create online classes whereby they can store the course materials online; manage assignments, quizzes and exams, monitor due dates, grade results and provide students with feedback all in one place.`;

//   // Carrega as vozes disponíveis no navegador
//   useEffect(() => {
//     const loadVoices = () => {
//       const availableVoices = window.speechSynthesis.getVoices();
//       setVoices(availableVoices);
//     };

//     loadVoices();
//     // Algumas vezes as vozes não estão disponíveis imediatamente, então adicionamos um listener
//     window.speechSynthesis.onvoiceschanged = loadVoices;

//     return () => {
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }, []);

//   // Função para aumentar o tamanho do texto
//   const increaseFontSize = () => {
//     setFontSize((prevSize) => Math.min(prevSize + 2, 32)); // Limite máximo de 32px
//   };

//   // Função para reduzir o tamanho do texto
//   const decreaseFontSize = () => {
//     setFontSize((prevSize) => Math.max(prevSize - 2, 12)); // Limite mínimo de 12px
//   };

//   // Função para aplicar leitura biônica
//   const toggleBionicReading = () => {
//     setIsBionic(!isBionic);
//   };

//   // Função para leitura por voz robótica
//   const toggleVoiceReading = () => {
//     if (isReading) {
//       window.speechSynthesis.cancel(); // Para a leitura
//       setIsReading(false);
//     } else {
//       const utterance = new SpeechSynthesisUtterance(textContent);
//       utterance.lang = voiceLang; // Define o idioma
//       utterance.rate = voiceSpeed; // Define a velocidade

//       // Seleciona a voz com base no gênero e idioma
//       const selectedVoice = voices.find((voice) => {
//         const isLangMatch = voice.lang === voiceLang;
//         const isGenderMatch =
//           voice.name.toLowerCase().includes(voiceGender) ||
//           (voiceGender === 'female' && voice.name.toLowerCase().includes('female')) ||
//           (voiceGender === 'male' && voice.name.toLowerCase().includes('male'));
//         return isLangMatch && (isGenderMatch || true); // Fallback se não houver correspondência exata de gênero
//       });

//       if (selectedVoice) {
//         utterance.voice = selectedVoice;
//       }

//       window.speechSynthesis.speak(utterance);
//       setIsReading(true);

//       utterance.onend = () => {
//         setIsReading(false); // Atualiza o estado quando a leitura termina
//       };
//     }
//   };

//   // Função para aplicar formatação biônica ao texto
//   const applyBionicReading = (text) => {
//     if (!isBionic) return text;

//     return text.split(' ').map((word, index) => {
//       const midPoint = Math.ceil(word.length / 2);
//       const firstHalf = word.slice(0, midPoint);
//       const secondHalf = word.slice(midPoint);
//       return (
//         <span key={index}>
//           <b>{firstHalf}</b>{secondHalf}{' '}
//         </span>
//       );
//     });
//   };

//   return (
//     <div className="read-page-container">
//       {/* Imagem Principal */}
//       <div className="header-image">
//         <img src={classroomImage} alt="Classroom" />
//       </div>

//       {/* Botões de Funcionalidade */}
//       <div className="controls">
//         <div className="font-size-controls">
//           <button onClick={increaseFontSize} className="control-btn">
//             Increase Font Size
//           </button>
//           <button onClick={decreaseFontSize} className="control-btn">
//             Decrease Font Size
//           </button>
//         </div>
//         <button onClick={toggleBionicReading} className="control-btn">
//           {isBionic ? 'Disable Bionic Reading' : 'Enable Bionic Reading'}
//         </button>
//         <div className="voice-controls">
//           <button onClick={toggleVoiceReading} className="control-btn">
//             {isReading ? 'Stop Voice Reading' : 'Start Voice Reading'}
//           </button>
//           <div className="voice-options">
//             <select
//               value={voiceSpeed}
//               onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}
//             >
//               <option value={0.5}>Slow (0.5x)</option>
//               <option value={1}>Normal (1x)</option>
//               <option value={1.5}>Fast (1.5x)</option>
//             </select>
//             <select
//               value={voiceGender}
//               onChange={(e) => setVoiceGender(e.target.value)}
//             >
//               <option value="female">Female Voice</option>
//               <option value="male">Male Voice</option>
//             </select>
//             <select
//               value={voiceLang}
//               onChange={(e) => setVoiceLang(e.target.value)}
//             >
//               <option value="en-US">English (US)</option>
//               <option value="pt-BR">Portuguese (Brazil)</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Conteúdo Principal */}
//       <div className="content">
//         <h1>Why Swift UI Should Be on the Radar of Every Mobile Developer</h1>
//         <p style={{ fontSize: `${fontSize}px` }} className="main-text">
//           {applyBionicReading(textContent)}
//         </p>
//         <div className="tags">
//           <span className="tag">interface</span>
//           <span className="tag">learning</span>
//           <span className="tag">mobile</span>
//           <span className="tag">masterclass</span>
//         </div>
//         <div className="author">
//           <span>Written By: Lena</span>
//           <button className="follow-btn">Follow</button>
//         </div>
//       </div>

//       {/* Seção de Blogs Relacionados */}
//       <div className="related-blogs">
//         <h2>Related Blog</h2>
//         <div className="blog-posts">
//           <div className="blog-post">
//             <img src={blogImage1} alt="Blog 1" />
//             <h3>Class adds $30 million to its balance sheet for a Zoom-friendly edtech solution</h3>
//             <p>Class, launched less than a year ago by Blackboard co-founder Michael Chasen, integrates exclusively...</p>
//             <a href="#" className="read-more">Read More</a>
//             <span className="views">38,123</span>
//           </div>
//           <div className="blog-post">
//             <img src={blogImage2} alt="Blog 2" />
//             <h3>Class adds $30 million to its balance sheet for a Zoom-friendly edtech solution</h3>
//             <p>Class, launched less than a year ago by Blackboard co-founder Michael Chasen, integrates exclusively...</p>
//             <a href="#" className="read-more">Read More</a>
//             <span className="views">38,123</span>
//           </div>
//         </div>
//         <div className="pagination">
//           <button className="pagination-btn">{'<'}</button>
//           <button className="pagination-btn">{'>'}</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadPage;




// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import './ReadPage.css';
// import classroomImage from '../as.avif'; // Substitua pelo caminho correto da sua imagem
// import blogImage1 from '../as.avif'; // Substitua pelo caminho correto da sua imagem de blog
// import blogImage2 from '../as.avif'; // Substitua pelo caminho correto da sua imagem de blog

// const ReadPage = () => {
//   const { contentId } = useParams(); // Corrigido de 'contentoId' para 'contentId'
//   const [fontSize, setFontSize] = useState(16);
//   const [isBionic, setIsBionic] = useState(false); // Corrigido de 'isthIsBionic' para 'isBionic'
//   const [isReading, setIsReading] = useState(false);
//   const [voiceSpeed, setVoiceSpeed] = useState(1);
//   const [voiceGender, setVoiceGender] = useState('female');
//   const [voiceLang, setVoiceLang] = useState('en-US');
//   const [voices, setVoices] = useState([]);

//   // Mapa de conteúdos com base no ID
//   const contentMap = {
//     'algebra-basica': 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais de álgebra, incluindo equações lineares e manipulação de variáveis.',
//     'fracoes': 'Conteúdo sobre Frações: Aprenda operações com frações, simplificação e resolução de problemas práticos.',
//     'geometria-plana': 'Conteúdo sobre Geometria Plana: Estudo de formas geométricas bidimensionais, como triângulos e círculos.',
//     'equacoes-quadraticas': 'Conteúdo sobre Equações Quadráticas: Resolução de equações do segundo grau e suas aplicações.',
//     'trigonometria': 'Conteúdo sobre Trigonometria: Funções trigonométricas e suas aplicações em cálculos geométricos.',
//     'gramatica-fundamental': 'Conteúdo sobre Gramática Fundamental: Regras básicas de gramática portuguesa.',
//     'literatura-mocambicana': 'Conteúdo sobre Literatura Moçambicana: Estudo de autores e obras representativas de Moçambique.',
//     'biologia-celular': 'Conteúdo sobre Biologia Celular: Estrutura e função das células.',
//     'fisica-basica': 'Conteúdo sobre Física Básica: Conceitos fundamentais de mecânica e energia.',
//     'historia-mocambique': 'Conteúdo sobre História de Moçambique: Eventos históricos e sua relevância.',
//     'geografia-fisica': 'Conteúdo sobre Geografia Física: Estudo dos fenômenos naturais e paisagens.',
//   };

//   const textContent = contentMap[contentId] || 'Conteúdo não encontrado.';

//   // Carrega as vozes disponíveis no navegador
//   useEffect(() => {
//     const loadVoices = () => {
//       const availableVoices = window.speechSynthesis.getVoices();
//       setVoices(availableVoices);
//     };

//     loadVoices();
//     window.speechSynthesis.onvoiceschanged = loadVoices;

//     return () => {
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }, []);

//   // Função para aumentar o tamanho do texto
//   const increaseFontSize = () => {
//     setFontSize((prevSize) => Math.min(prevSize + 2, 32));
//   };

//   // Função para reduzir o tamanho do texto
//   const decreaseFontSize = () => {
//     setFontSize((prevSize) => Math.max(prevSize - 2, 12));
//   };

//   // Função para aplicar leitura biônica
//   const applyBionicReading = (text) => {
//     if (!isBionic) return text;

//     return text.split(' ').map((word, index) => {
//       const midPoint = Math.ceil(word.length / 2);
//       const firstHalf = word.slice(0, midPoint);
//       const secondHalf = word.slice(midPoint);
//       return (
//         <span key={index}>
//           <b>{firstHalf}</b>
//           {secondHalf}{' '}
//         </span>
//       );
//     });
//   };

//   // Função para leitura por voz robótica
//   const toggleVoiceReading = () => {
//     if (isReading) {
//       window.speechSynthesis.cancel();
//       setIsReading(false);
//     } else {
//       const utterance = new SpeechSynthesisUtterance(textContent);
//       utterance.lang = voiceLang;
//       utterance.rate = voiceSpeed;

//       const selectedVoice = voices.find((voice) => {
//         const isLangMatch = voice.lang === voiceLang;
//         const isGenderMatch =
//           voice.name.toLowerCase().includes(voiceGender) ||
//           (voiceGender === 'female' && voice.name.toLowerCase().includes('female')) ||
//           (voiceGender === 'male' && voice.name.toLowerCase().includes('male'));
//         return isLangMatch && (isGenderMatch || true);
//       });

//       if (selectedVoice) {
//         utterance.voice = selectedVoice;
//       }

//       window.speechSynthesis.speak(utterance);
//       setIsReading(true);

//       utterance.onend = () => {
//         setIsReading(false);
//       };
//     }
//   };

//   return (
//     <div className="read-page-container">
//       {/* Imagem Principal */}
//       <div className="header-image">
//         <img src={classroomImage} alt="Classroom" />
//       </div>

//       {/* Botões de Funcionalidade */}
//       <div className="controls">
//         <div className="font-size-controls">
//           <button onClick={increaseFontSize} className="control-btn">
//             Increase Font Size
//           </button>
//           <button onClick={decreaseFontSize} className="control-btn">
//             Decrease Font Size
//           </button>
//         </div>
//         <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
//           {isBionic ? 'Disable Bionic Reading' : 'Enable Bionic Reading'}
//         </button>
//         <div className="voice-controls">
//           <button onClick={toggleVoiceReading} className="control-btn">
//             {isReading ? 'Stop Voice Reading' : 'Start Voice Reading'}
//           </button>
//           <div className="voice-options">
//             <select
//               value={voiceSpeed}
//               onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}
//             >
//               <option value={0.5}>Slow (0.5x)</option>
//               <option value={1}>Normal (1x)</option>
//               <option value={1.5}>Fast (1.5x)</option>
//             </select>
//             <select
//               value={voiceGender}
//               onChange={(e) => setVoiceGender(e.target.value)}
//             >
//               <option value="female">Female Voice</option>
//               <option value="male">Male Voice</option>
//             </select>
//             <select
//               value={voiceLang}
//               onChange={(e) => setVoiceLang(e.target.value)}
//             >
//               <option value="en-US">English (US)</option>
//               <option value="pt-BR">Portuguese (Brazil)</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Conteúdo Principal */}
//       <div className="content">
//         <h1>{contentId ? contentId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo'}</h1>
//         <p style={{ fontSize: `${fontSize}px` }} className="main-text">
//           {applyBionicReading(textContent)}
//         </p>
//         <div className="tags">
//           <span className="tag">interface</span>
//           <span className="tag">learning</span>
//           <span className="tag">mobile</span>
//           <span className="tag">masterclass</span>
//         </div>
//         <div className="author">
//           <span>Written By: Lena</span>
//           <button className="follow-btn">Follow</button>
//         </div>
//       </div>

//       {/* Seção de Blogs Relacionados */}
//       <div className="related-blogs">
//         <h2>Related Blog</h2>
//         <div className="blog-posts">
//           <div className="blog-post">
//             <img src={blogImage1} alt="Blog 1" />
//             <h3>Class adds $30 million to its balance sheet for a Zoom-friendly edtech solution</h3>
//             <p>Class, launched less than a year ago by Blackboard co-founder Michael Chasen, integrates exclusively...</p>
//             <a href="#" className="read-more">Read More</a>
//             <span className="views">38,123</span>
//           </div>
//           <div className="blog-post">
//             <img src={blogImage2} alt="Blog 2" />
//             <h3>Class adds $30 million to its balance sheet for a Zoom-friendly edtech solution</h3>
//             <p>Class, launched less than a year ago by Blackboard co-founder Michael Chasen, integrates exclusively...</p>
//             <a href="#" className="read-more">Read More</a>
//             <span className="views">38,123</span>
//           </div>
//         </div>
//         <div className="pagination">
//           <button className="pagination-btn">{'<'}</button>
//           <button className="pagination-btn">{'>'}</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadPage;

// gggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggg

// hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh

// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import './ReadPage.css';
// import classroomImage from '../as.avif';
// import { contentList } from './ContentPage'; // Verifique o caminho da importação

// const ReadPage = () => {
//   const { contentId } = useParams();
//   const [fontSize, setFontSize] = useState(16);
//   const [isBionic, setIsBionic] = useState(false);
//   const [isReading, setIsReading] = useState(false);
//   const [voiceSpeed, setVoiceSpeed] = useState(1);
//   const [voiceGender, setVoiceGender] = useState('female');
//   const [voiceLang, setVoiceLang] = useState('en-US');
//   const [voices, setVoices] = useState([]);

//   // Depuração: Verificar se contentList foi importado
//   console.log('contentList:', contentList);

//   const contentMap = {
    // // Matemática
    // 'algebra-basica': 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais de álgebra, incluindo equações lineares e manipulação de variáveis.',
    // 'fracoes': 'Conteúdo sobre Frações: Aprenda operações com frações, simplificação e resolução de problemas práticos.',
    // 'numeros-inteiros': 'Conteúdo sobre Números Inteiros: Estudo das propriedades e operações com números inteiros.',
    // 'geometria-plana': 'Conteúdo sobre Geometria Plana: Estudo de formas geométricas bidimensionais, como triângulos e círculos.',
    // 'equacoes-quadraticas': 'Conteúdo sobre Equações Quadráticas: Resolução de equações do segundo grau e suas aplicações.',
    // 'funcoes-lineares': 'Conteúdo sobre Funções Lineares: Introdução às funções lineares e suas representações gráficas.',
    // 'trigonometria': 'Conteúdo sobre Trigonometria: Funções trigonométricas e suas aplicações em cálculos geométricos.',
    // 'matrizes': 'Conteúdo sobre Matrizes: Operações com matrizes e suas aplicações em sistemas lineares.',
    // 'probabilidade': 'Conteúdo sobre Probabilidade: Conceitos básicos de probabilidade e eventos aleatórios.',
    // // Português
    // 'gramatica-fundamental': 'Conteúdo sobre Gramática Fundamental: Regras básicas de gramática portuguesa, incluindo concordância e regência.',
    // 'ortografia-pontuacao': 'Conteúdo sobre Ortografia e Pontuação: Regras de escrita correta e uso de sinais de pontuação.',
    // 'leitura-interpretacao': 'Conteúdo sobre Leitura e Interpretação: Técnicas para compreender e analisar textos diversos.',
    // 'literatura-mocambicana': 'Conteúdo sobre Literatura Moçambicana: Estudo de autores e obras representativas de Moçambique.',
    // 'redacao-narrativa': 'Conteúdo sobre Redação Narrativa: Estrutura e técnicas para escrever textos narrativos.',
    // 'analise-textos': 'Conteúdo sobre Análise de Textos: Métodos para interpretar e criticar textos literários e não literários.',
    // 'literatura-portuguesa': 'Conteúdo sobre Literatura Portuguesa: Estudo de autores clássicos e contemporâneos de Portugal.',
    // 'redacao-argumentativa': 'Conteúdo sobre Redação Argumentativa: Técnicas para construir argumentos sólidos em textos dissertativos.',
    // 'figuras-linguagem': 'Conteúdo sobre Figuras de Linguagem: Identificação e uso de recursos estilísticos na língua portuguesa.',
    // // Ciências
    // 'biologia-celular': 'Conteúdo sobre Biologia Celular: Estrutura e função das células, incluindo organelas e processos celulares.',
    // 'ecossistemas': 'Conteúdo sobre Ecossistemas: Interações entre organismos e o ambiente em diferentes ecossistemas.',
    // 'quimica-basica': 'Conteúdo sobre Química Básica: Conceitos fundamentais de átomos, moléculas e reações químicas.',
    // 'fisica-basica': 'Conteúdo sobre Física Básica: Conceitos fundamentais de mecânica e energia.',
    // 'reacoes-quimicas': 'Conteúdo sobre Reações Químicas: Tipos de reações e balanceamento de equações químicas.',
    // 'genetica': 'Conteúdo sobre Genética: Princípios de hereditariedade e leis de Mendel.',
    // 'mecanica-classica': 'Conteúdo sobre Mecânica Clássica: Leis de Newton e suas aplicações.',
    // 'quimica-organica': 'Conteúdo sobre Química Orgânica: Introdução aos compostos orgânicos e suas propriedades.',
    // 'evolucao-biologica': 'Conteúdo sobre Evolução Biológica: Teoria da evolução e seleção natural.',
    // // História
    // 'historia-mocambique': 'Conteúdo sobre História de Moçambique: Eventos históricos e sua relevância para o país.',
    // 'civilizacoes-africanas': 'Conteúdo sobre Civilizações Africanas: Estudo das grandes civilizações pré-coloniais da África.',
    // 'colonizacao-europeia': 'Conteúdo sobre Colonização Europeia: Impactos da colonização em África e Moçambique.',
    // 'independencia-mocambique': 'Conteúdo sobre Independência de Moçambique: Processo de luta pela independência e seus desdobramentos.',
    // 'primeira-guerra-mundial': 'Conteúdo sobre Primeira Guerra Mundial: Causas, eventos e consequências globais.',
    // 'revolucoes-seculo-xx': 'Conteúdo sobre Revoluções do Século XX: Estudo das revoluções que marcaram o século passado.',
    // 'guerra-fria': 'Conteúdo sobre Guerra Fria: Conflitos ideológicos e geopolíticos entre EUA e URSS.',
    // 'historia-contemporanea': 'Conteúdo sobre História Contemporânea: Eventos globais do final do século XX e início do XXI.',
    // 'movimentos-libertacao': 'Conteúdo sobre Movimentos de Libertação: Lutas anticoloniais na África e no mundo.',
    // // Geografia
    // 'geografia-fisica': 'Conteúdo sobre Geografia Física: Estudo dos fenômenos naturais e paisagens.',
    // 'climas-mundo': 'Conteúdo sobre Climas do Mundo: Classificação e características dos climas globais.',
    // 'relevo-terrestre': 'Conteúdo sobre Relevo Terrestre: Formação e tipos de relevo na superfície terrestre.',
    // 'geografia-humana': 'Conteúdo sobre Geografia Humana: Dinâmicas populacionais e atividades econômicas.',
    // 'urbanizacao': 'Conteúdo sobre Urbanização: Crescimento das cidades e seus desafios.',
    // 'recursos-naturais': 'Conteúdo sobre Recursos Naturais: Uso e conservação dos recursos naturais.',
    // 'globalizacao': 'Conteúdo sobre Globalização: Impactos econômicos, culturais e sociais da globalização.',
    // 'geopolitica': 'Conteúdo sobre Geopolítica: Relações de poder entre nações e conflitos globais.',
    // 'mudancas-climaticas': 'Conteúdo sobre Mudanças Climáticas: Causas, efeitos e estratégias de mitigação.',
//   };

//   const textContent = contentMap[contentId] || 'Conteúdo não encontrado.';

//   // Encontrar a disciplina e classe do tema atual
//   let relatedTopics = [];
//   let currentSubject = null;
//   let currentClass = null;

//   // Depuração: Verificar o contentId
//   console.log('contentId:', contentId);

//   // Buscar disciplina e classe
//   if (contentList) {
//     Object.entries(contentList).some(([subject, classes]) => {
//       return Object.entries(classes).some(([className, topics]) => {
//         const currentTopic = topics.find((topic) => topic.id === contentId);
//         if (currentTopic) {
//           currentSubject = subject;
//           currentClass = className;
//           // Filtrar temas da mesma classe e disciplina, excluindo o tema atual
//           relatedTopics = topics
//             .filter((topic) => topic.id !== contentId)
//             .slice(0, 2); // Pegar até 2 temas relacionados
//           return true; // Para o loop interno
//         }
//         return false;
//       });
//     });
//   } else {
//     console.error('contentList is undefined or not imported correctly');
//   }

//   // Depuração: Verificar resultados
//   console.log('currentSubject:', currentSubject);
//   console.log('currentClass:', currentClass);
//   console.log('relatedTopics:', relatedTopics);

//   useEffect(() => {
//     const loadVoices = () => {
//       const availableVoices = window.speechSynthesis.getVoices();
//       setVoices(availableVoices);
//     };

//     loadVoices();
//     window.speechSynthesis.onvoiceschanged = loadVoices;

//     return () => {
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }, []);

//   const increaseFontSize = () => {
//     setFontSize((prevSize) => Math.min(prevSize + 2, 32));
//   };

//   const decreaseFontSize = () => {
//     setFontSize((prevSize) => Math.max(prevSize - 2, 12));
//   };

//   const applyBionicReading = (text) => {
//     if (!isBionic) return text;

//     return text.split(' ').map((word, index) => {
//       const midPoint = Math.ceil(word.length / 2);
//       const firstHalf = word.slice(0, midPoint);
//       const secondHalf = word.slice(midPoint);
//       return (
//         <span key={index}>
//           <b>{firstHalf}</b>
//           {secondHalf}{' '}
//         </span>
//       );
//     });
//   };

//   const toggleVoiceReading = () => {
//     if (isReading) {
//       window.speechSynthesis.cancel();
//       setIsReading(false);
//     } else {
//       const utterance = new SpeechSynthesisUtterance(textContent);
//       utterance.lang = voiceLang;
//       utterance.rate = voiceSpeed;

//       const selectedVoice = voices.find((voice) => {
//         const isLangMatch = voice.lang === voiceLang;
//         const isGenderMatch =
//           voice.name.toLowerCase().includes(voiceGender) ||
//           (voiceGender === 'female' && voice.name.toLowerCase().includes('female')) ||
//           (voiceGender === 'male' && voice.name.toLowerCase().includes('male'));
//         return isLangMatch && (isGenderMatch || true);
//       });

//       if (selectedVoice) {
//         utterance.voice = selectedVoice;
//       }

//       window.speechSynthesis.speak(utterance);
//       setIsReading(true);

//       utterance.onend = () => {
//         setIsReading(false);
//       };
//     }
//   };

//   return (
//     <div className="read-page-container">
//       <div className="header-image">
//         <img src={classroomImage} alt="Classroom" />
//       </div>
//       <div className="controls">
//         <div className="font-size-controls">
//           <button onClick={increaseFontSize} className="control-btn">
//             Aumentar Tamanho
//           </button>
//           <button onClick={decreaseFontSize} className="control-btn">
//             Diminuir Tamanho
//           </button>
//         </div>
//         <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
//           {isBionic ? 'Desactivar Leitura Bionica' : 'Activar Leitura Bionica'}
//         </button>
//         <div className="voice-controls">
//           <button onClick={toggleVoiceReading} className="control-btn">
//             {/* {isReading ? 'Stop Voice Reading' : 'Start Voice Reading'} */}
//             {isReading ? 'Parar Leitura por Voz' : 'Comecar Leitura por Voz'}
//           </button>
//           <div className="voice-options">
//             <select
//               value={voiceSpeed}
//               onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}
//             >
//               <option value={0.5}>Lento (0.5x)</option>
//               <option value={1}>Normal (1x)</option>
//               <option value={1.5}>Rapido (1.5x)</option>
//             </select>
//             <select
//               value={voiceGender}
//               onChange={(e) => setVoiceGender(e.target.value)}
//             >
//               <option value="female">Voz Feminina</option>
//               <option value="male">Voz Masculina</option>
//             </select>
//             <select
//               value={voiceLang}
//               onChange={(e) => setVoiceLang(e.target.value)}
//             >
//               <option value="en-US">Ingles (US)</option>
//               <option value="pt-BR">Portugues (Brazil)</option>
//             </select>
//           </div>
//         </div>
//       </div>
//       <div className="content">
//         <h1>{contentId ? contentId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo'}</h1>
//         <p style={{ fontSize: `${fontSize}px` }} className="main-text">
//           {applyBionicReading(textContent)}
//         </p>
//         <div className="tags">
//           <span className="tag">interface</span>
//           <span className="tag">learning</span>
//           <span className="tag">mobile</span>
//           <span className="tag">masterclass</span>
//         </div>
//         <div className="author">
//           <span>Written By: Lena</span>
//           <button className="follow-btn">Follow</button>
//         </div>
//       </div>
//       <div className="related-blogs">
//         <h2>Temas Relacionados</h2>
//         <div className="blog-posts">
//           {relatedTopics.length > 0 ? (
//             relatedTopics.map((topic) => (
//               <Link
//                 key={topic.id}
//                 to={`/read/${topic.id}`}
//                 className="blog-post"
//               >
//                 <h3>{topic.title}</h3>
//                 <p>Data: {topic.date}</p>
//                 <span className="read-more">Ler Mais</span>
//               </Link>
//             ))
//           ) : (
//             <p>Nenhum tema relacionado disponível.</p>
//           )}
//         </div>
//         <div className="pagination">
//           <button className="pagination-btn">{'<'}</button>
//           <button className="pagination-btn">{'>'}</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadPage;

// HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH

// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import './ReadPage.css';
// import classroomImage from '../as.avif';
// import { contentList } from './ContentPage';

// const ReadPage = () => {
//   const { contentId } = useParams();
//   const normalizedId = contentId ? contentId.toLowerCase() : null;

//   const [fontSize, setFontSize] = useState(16);
//   const [isBionic, setIsBionic] = useState(false);
//   const [isReading, setIsReading] = useState(false);
//   const [voiceSpeed, setVoiceSpeed] = useState(1);
//   const [voiceGender, setVoiceGender] = useState('female');
//   const [voiceLang, setVoiceLang] = useState('pt-BR');
//   const [voices, setVoices] = useState([]);

//   let currentTopic = null;
//   let currentSubject = null;
//   let currentClass = null;
//   let relatedTopics = [];

//   // 🔎 Procurar no contentList (sempre comparando em minúsculas)
//   if (contentList) {
//     Object.entries(contentList).forEach(([subject, classes]) => {
//       Object.entries(classes).forEach(([className, topics]) => {
//         const found = topics.find((topic) => topic.id.toLowerCase() === normalizedId);
//         if (found) {
//           currentTopic = found;
//           currentSubject = subject;
//           currentClass = className;
//           relatedTopics = topics.filter((t) => t.id.toLowerCase() !== normalizedId).slice(0, 2);
//         }
//       });
//     });
//   }

//   // Conteúdo principal
//   let textContent = currentTopic
//     ? (currentTopic.content || currentTopic.title)
//     : 'Conteúdo não encontrado.';

//   // 🎯 Fallback com contentMap
//   const contentMap = {
//     // Matemática
//     'algebra-basica': 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais de álgebra, incluindo equações lineares e manipulação de variáveis.',
//     'fracoes': 'Conteúdo sobre Frações: Aprenda operações com frações, simplificação e resolução de problemas práticos.',
//     'numeros-inteiros': 'Conteúdo sobre Números Inteiros: Estudo das propriedades e operações com números inteiros.',
//     'geometria-plana': 'Conteúdo sobre Geometria Plana: Estudo de formas geométricas bidimensionais, como triângulos e círculos.',
//     'equacoes-quadraticas': 'Conteúdo sobre Equações Quadráticas: Resolução de equações do segundo grau e suas aplicações.',
//     'funcoes-lineares': 'Conteúdo sobre Funções Lineares: Introdução às funções lineares e suas representações gráficas.',
//     'trigonometria': 'Conteúdo sobre Trigonometria: Funções trigonométricas e suas aplicações em cálculos geométricos.',
//     'matrizes': 'Conteúdo sobre Matrizes: Operações com matrizes e suas aplicações em sistemas lineares.',
//     'probabilidade': 'Conteúdo sobre Probabilidade: Conceitos básicos de probabilidade e eventos aleatórios.',
//     // Português
//     'gramatica-fundamental': 'Conteúdo sobre Gramática Fundamental: Regras básicas de gramática portuguesa, incluindo concordância e regência.',
//     'ortografia-pontuacao': 'Conteúdo sobre Ortografia e Pontuação: Regras de escrita correta e uso de sinais de pontuação.',
//     'leitura-interpretacao': 'Conteúdo sobre Leitura e Interpretação: Técnicas para compreender e analisar textos diversos.',
//     'literatura-mocambicana': 'Conteúdo sobre Literatura Moçambicana: Estudo de autores e obras representativas de Moçambique.',
//     'redacao-narrativa': 'Conteúdo sobre Redação Narrativa: Estrutura e técnicas para escrever textos narrativos.',
//     'analise-textos': 'Conteúdo sobre Análise de Textos: Métodos para interpretar e criticar textos literários e não literários.',
//     'literatura-portuguesa': 'Conteúdo sobre Literatura Portuguesa: Estudo de autores clássicos e contemporâneos de Portugal.',
//     'redacao-argumentativa': 'Conteúdo sobre Redação Argumentativa: Técnicas para construir argumentos sólidos em textos dissertativos.',
//     'figuras-linguagem': 'Conteúdo sobre Figuras de Linguagem: Identificação e uso de recursos estilísticos na língua portuguesa.',
//     // Ciências
//     'biologia-celular': 'Conteúdo sobre Biologia Celular: Estrutura e função das células, incluindo organelas e processos celulares.',
//     'ecossistemas': 'Conteúdo sobre Ecossistemas: Interações entre organismos e o ambiente em diferentes ecossistemas.',
//     'quimica-basica': 'Conteúdo sobre Química Básica: Conceitos fundamentais de átomos, moléculas e reações químicas.',
//     'fisica-basica': 'Conteúdo sobre Física Básica: Conceitos fundamentais de mecânica e energia.',
//     'reacoes-quimicas': 'Conteúdo sobre Reações Químicas: Tipos de reações e balanceamento de equações químicas.',
//     'genetica': 'Conteúdo sobre Genética: Princípios de hereditariedade e leis de Mendel.',
//     'mecanica-classica': 'Conteúdo sobre Mecânica Clássica: Leis de Newton e suas aplicações.',
//     'quimica-organica': 'Conteúdo sobre Química Orgânica: Introdução aos compostos orgânicos e suas propriedades.',
//     'evolucao-biologica': 'Conteúdo sobre Evolução Biológica: Teoria da evolução e seleção natural.',
//     // História
//     'historia-mocambique': 'Conteúdo sobre História de Moçambique: Eventos históricos e sua relevância para o país.',
//     'civilizacoes-africanas': 'Conteúdo sobre Civilizações Africanas: Estudo das grandes civilizações pré-coloniais da África.',
//     'colonizacao-europeia': 'Conteúdo sobre Colonização Europeia: Impactos da colonização em África e Moçambique.',
//     'independencia-mocambique': 'Conteúdo sobre Independência de Moçambique: Processo de luta pela independência e seus desdobramentos.',
//     'primeira-guerra-mundial': 'Conteúdo sobre Primeira Guerra Mundial: Causas, eventos e consequências globais.',
//     'revolucoes-seculo-xx': 'Conteúdo sobre Revoluções do Século XX: Estudo das revoluções que marcaram o século passado.',
//     'guerra-fria': 'Conteúdo sobre Guerra Fria: Conflitos ideológicos e geopolíticos entre EUA e URSS.',
//     'historia-contemporanea': 'Conteúdo sobre História Contemporânea: Eventos globais do final do século XX e início do XXI.',
//     'movimentos-libertacao': 'Conteúdo sobre Movimentos de Libertação: Lutas anticoloniais na África e no mundo.',
//     // Geografia
//     'geografia-fisica': 'Conteúdo sobre Geografia Física: Estudo dos fenômenos naturais e paisagens.',
//     'climas-mundo': 'Conteúdo sobre Climas do Mundo: Classificação e características dos climas globais.',
//     'relevo-terrestre': 'Conteúdo sobre Relevo Terrestre: Formação e tipos de relevo na superfície terrestre.',
//     'geografia-humana': 'Conteúdo sobre Geografia Humana: Dinâmicas populacionais e atividades econômicas.',
//     'urbanizacao': 'Conteúdo sobre Urbanização: Crescimento das cidades e seus desafios.',
//     'recursos-naturais': 'Conteúdo sobre Recursos Naturais: Uso e conservação dos recursos naturais.',
//     'globalizacao': 'Conteúdo sobre Globalização: Impactos econômicos, culturais e sociais da globalização.',
//     'geopolitica': 'Conteúdo sobre Geopolítica: Relações de poder entre nações e conflitos globais.',
//     'mudancas-climaticas': 'Conteúdo sobre Mudanças Climáticas: Causas, efeitos e estratégias de mitigação.',
//   };

//   if (textContent === 'Conteúdo não encontrado.') {
//     textContent = contentMap[normalizedId] || 'Conteúdo não encontrado.';
//   }

//   // ===================== LEITURA POR VOZ =====================
//   useEffect(() => {
//     const loadVoices = () => {
//       const availableVoices = window.speechSynthesis.getVoices();
//       setVoices(availableVoices);
//     };

//     loadVoices();
//     window.speechSynthesis.onvoiceschanged = loadVoices;

//     return () => {
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }, []);

//   const toggleVoiceReading = () => {
//     if (isReading) {
//       window.speechSynthesis.cancel();
//       setIsReading(false);
//     } else {
//       const utterance = new SpeechSynthesisUtterance(textContent);
//       utterance.lang = voiceLang;
//       utterance.rate = voiceSpeed;

//       const selectedVoice = voices.find((voice) => voice.lang === voiceLang);
//       if (selectedVoice) utterance.voice = selectedVoice;

//       window.speechSynthesis.speak(utterance);
//       setIsReading(true);

//       utterance.onend = () => setIsReading(false);
//     }
//   };

//   // ===================== LEITURA BIÓNICA =====================
//   const applyBionicReading = (text) => {
//     if (!isBionic) return text;
//     return text.split(' ').map((word, index) => {
//       const midPoint = Math.ceil(word.length / 2);
//       return (
//         <span key={index}>
//           <b>{word.slice(0, midPoint)}</b>
//           {word.slice(midPoint)}{' '}
//         </span>
//       );
//     });
//   };

//   return (
//     <div className="read-page-container">
//       <div className="header-image">
//         <img src={classroomImage} alt="Classroom" />
//       </div>

//       {/* ======= Controles ======= */}
//       <div className="controls">
//         <div className="font-size-controls">
//           <button onClick={() => setFontSize((s) => Math.min(s + 2, 32))} className="control-btn">
//             Aumentar
//           </button>
//           <button onClick={() => setFontSize((s) => Math.max(s - 2, 12))} className="control-btn">
//             Diminuir
//           </button>
//         </div>
//         <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
//           {isBionic ? 'Desativar Biónico' : 'Ativar Biónico'}
//         </button>
//         <div className="voice-controls">
//           <button onClick={toggleVoiceReading} className="control-btn">
//             {isReading ? 'Parar Voz' : 'Ler por Voz'}
//           </button>
//           <div className="voice-options">
//             <select value={voiceSpeed} onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}>
//               <option value={0.5}>Lento</option>
//               <option value={1}>Normal</option>
//               <option value={1.5}>Rápido</option>
//             </select>
//             <select value={voiceGender} onChange={(e) => setVoiceGender(e.target.value)}>
//               <option value="female">Feminina</option>
//               <option value="male">Masculina</option>
//             </select>
//             <select value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)}>
//               <option value="pt-BR">Português</option>
//               <option value="en-US">Inglês</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* ======= Conteúdo ======= */}
//       <div className="content">
//         <h1>
//           {currentTopic?.title ||
//             (normalizedId ? normalizedId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo')}
//         </h1>

//         <p style={{ fontSize: `${fontSize}px` }} className="main-text">
//           {applyBionicReading(textContent)}
//         </p>

//         <div className="author">
//           <span>
//             Disciplina: {currentSubject || 'N/A'} | Classe: {currentClass || 'N/A'}
//           </span>
//         </div>
//       </div>

//       {/* ======= Relacionados ======= */}
//       <div className="related-blogs">
//         <h2>Temas Relacionados</h2>
//         <div className="blog-posts">
//           {relatedTopics.length > 0 ? (
//             relatedTopics.map((topic) => (
//               <Link key={topic.id} to={`/read/${topic.id}`} className="blog-post">
//                 <h3>{topic.title}</h3>
//                 <p>Data: {topic.date}</p>
//                 <span className="read-more">Ler Mais</span>
//               </Link>
//             ))
//           ) : (
//             <p>Nenhum tema relacionado disponível.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadPage;

// HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH

// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import './ReadPage.css';
// import classroomImage from '../as.avif';
// import { contentList } from './ContentPage';

// const ReadPage = () => {
//   const { contentId } = useParams();
//   const normalizedId = contentId ? contentId.toLowerCase() : null;

//   const [fontSize, setFontSize] = useState(16);
//   const [isBionic, setIsBionic] = useState(false);
//   const [isReading, setIsReading] = useState(false);
//   const [voiceSpeed, setVoiceSpeed] = useState(1);
//   const [voiceGender, setVoiceGender] = useState('female');
//   const [voiceLang, setVoiceLang] = useState('pt-BR');
//   const [voices, setVoices] = useState([]);

//   let currentTopic = null;
//   let currentSubject = null;
//   let currentClass = null;
//   let relatedTopics = [];

//   // Procurar no contentList
//   if (contentList) {
//     Object.entries(contentList).forEach(([subject, classes]) => {
//       Object.entries(classes).forEach(([className, topics]) => {
//         const found = topics.find((topic) => topic.id.toLowerCase() === normalizedId);
//         if (found) {
//           currentTopic = found;
//           currentSubject = subject;
//           currentClass = className;
//           relatedTopics = topics.filter((t) => t.id.toLowerCase() !== normalizedId).slice(0, 2);
//         }
//       });
//     });
//   }

//   // Conteúdo base (fallback em caso de não existir)
//   const contentMap = {
//     'algebra-basica': 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais...',
//     'fracoes': 'Conteúdo sobre Frações: Aprenda operações com frações...',
//     'numeros-inteiros': 'Conteúdo sobre Números Inteiros: Estudo das propriedades e operações...',
//     'funcoes-lineares': 'Conteúdo sobre Funções Lineares: Introdução e gráficos...',
//     'trigonometria': 'Conteúdo sobre Trigonometria: Funções trigonométricas...',
//   };

//   let textContent =
//     currentTopic?.content || contentMap[normalizedId] || 'Conteúdo em preparação...';

//   // ===================== LEITURA POR VOZ =====================
//   useEffect(() => {
//     const loadVoices = () => {
//       const availableVoices = window.speechSynthesis.getVoices();
//       setVoices(availableVoices);
//     };

//     loadVoices();
//     window.speechSynthesis.onvoiceschanged = loadVoices;

//     return () => {
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }, []);

//   const toggleVoiceReading = () => {
//     if (isReading) {
//       window.speechSynthesis.cancel();
//       setIsReading(false);
//     } else {
//       const utterance = new SpeechSynthesisUtterance(textContent);
//       utterance.lang = voiceLang;
//       utterance.rate = voiceSpeed;

//       const selectedVoice = voices.find((voice) => voice.lang === voiceLang);
//       if (selectedVoice) utterance.voice = selectedVoice;

//       window.speechSynthesis.speak(utterance);
//       setIsReading(true);

//       utterance.onend = () => setIsReading(false);
//     }
//   };

//   // ===================== LEITURA BIÓNICA =====================
//   const applyBionicReading = (text) => {
//     if (!isBionic) return text;
//     return text.split(' ').map((word, index) => {
//       const midPoint = Math.ceil(word.length / 2);
//       return (
//         <span key={index}>
//           <b>{word.slice(0, midPoint)}</b>
//           {word.slice(midPoint)}{' '}
//         </span>
//       );
//     });
//   };

//   return (
//     <div className="read-page-container">
//       <div className="header-image">
//         <img src={classroomImage} alt="Classroom" />
//       </div>

//       {/* ======= Controles ======= */}
//       <div className="controls">
//         <div className="font-size-controls">
//           <button onClick={() => setFontSize((s) => Math.min(s + 2, 32))} className="control-btn">
//             Aumentar
//           </button>
//           <button onClick={() => setFontSize((s) => Math.max(s - 2, 12))} className="control-btn">
//             Diminuir
//           </button>
//         </div>
//         <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
//           {isBionic ? 'Desativar Biónico' : 'Ativar Biónico'}
//         </button>
//         <div className="voice-controls">
//           <button onClick={toggleVoiceReading} className="control-btn">
//             {isReading ? 'Parar Voz' : 'Ler por Voz'}
//           </button>
//           <div className="voice-options">
//             <select value={voiceSpeed} onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}>
//               <option value={0.5}>Lento</option>
//               <option value={1}>Normal</option>
//               <option value={1.5}>Rápido</option>
//             </select>
//             <select value={voiceGender} onChange={(e) => setVoiceGender(e.target.value)}>
//               <option value="female">Feminina</option>
//               <option value="male">Masculina</option>
//             </select>
//             <select value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)}>
//               <option value="pt-BR">Português</option>
//               <option value="en-US">Inglês</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* ======= Conteúdo ======= */}
//       <div className="content">
//         <h1>
//           {currentTopic?.title ||
//             (normalizedId ? normalizedId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo')}
//         </h1>

//         <p style={{ fontSize: `${fontSize}px` }} className="main-text">
//           {applyBionicReading(textContent)}
//         </p>

//         <div className="author">
//           <span>
//             Disciplina: {currentSubject || 'N/A'} | Classe: {currentClass || 'N/A'}
//           </span>
//         </div>
//       </div>

//       {/* ======= Relacionados ======= */}
//       <div className="related-blogs">
//         <h2>Temas Relacionados</h2>
//         <div className="blog-posts">
//           {relatedTopics.length > 0 ? (
//             relatedTopics.map((topic) => (
//               <Link key={topic.id} to={`/read/${topic.id}`} className="blog-post">
//                 <h3>{topic.title}</h3>
//                 <p>Data: {topic.date}</p>
//                 <span className="read-more">Ler Mais</span>
//               </Link>
//             ))
//           ) : (
//             <p>Nenhum tema relacionado disponível.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadPage;

// import React from "react";
// import { useParams, Link } from "react-router-dom";
// import { contentList } from "./ContentPage";
// import Header from "./Header";
// import Footer from "./Footer";
// import "./ReadPage.css";

// const contentMap = {
//   "algebra-basica": "O estudo da Álgebra Básica envolve expressões, equações e propriedades fundamentais.",
//   "fracoes": "Frações representam partes de um todo. Nesta lição você aprenderá a simplificar, somar e multiplicar.",
//   "numeros-inteiros": "Os números inteiros incluem positivos, negativos e o zero. Usados em situações do dia a dia.",
//   "geometria-plana": "Geometria plana estuda figuras bidimensionais como triângulos e circunferências.",
//   "equacoes-quadraticas": "Equações quadráticas: ax²+bx+c=0. Resolvidas pelo método de Bhaskara.",
//   "gramatica-fundamental": "A gramática fundamental aborda classes de palavras, concordância e pontuação básica.",
//   "ortografia-pontuacao": "Ortografia: forma correta das palavras. Pontuação: organiza e dá sentido ao texto."
// };

// const ReadPage = () => {
//   const { subject, classLevel, contentId } = useParams();

//   const topic =
//     contentList[subject] &&
//     contentList[subject][classLevel] &&
//     contentList[subject][classLevel].find((c) => c.id === contentId);

//   const textContent = contentMap[contentId] || "Conteúdo em preparação...";

//   return (
//     <div>
//       <Header />

//       <div className="read-page">
//         {topic ? (
//           <>
//             <h1>{topic.title}</h1>
//             <p>{textContent}</p>
//           </>
//         ) : (
//           <p>Conteúdo não encontrado.</p>
//         )}

//         <Link to="/conteudo" className="back-link">
//           ← Voltar
//         </Link>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default ReadPage;

// KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ReadPage.css';
import classroomImage from '../as.avif';
import { contentList } from './ContentPage';

const ReadPage = () => {
  const { contentId } = useParams();
  const normalizedId = contentId ? contentId.toLowerCase() : null;

  const [fontSize, setFontSize] = useState(16);
  const [isBionic, setIsBionic] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [voiceSpeed, setVoiceSpeed] = useState(1);
  const [voiceGender, setVoiceGender] = useState('female');
  const [voiceLang, setVoiceLang] = useState('pt-BR');
  const [voices, setVoices] = useState([]);

  let currentTopic = null;
  let currentSubject = null;
  let currentClass = null;
  let relatedTopics = [];

  // 🔎 Procurar no contentList (sempre comparando em minúsculas)
  if (contentList) {
    Object.entries(contentList).forEach(([subject, classes]) => {
      Object.entries(classes).forEach(([className, topics]) => {
        const found = topics.find((topic) => topic.id.toLowerCase() === normalizedId);
        if (found) {
          currentTopic = found;
          currentSubject = subject;
          currentClass = className;
          relatedTopics = topics.filter((t) => t.id.toLowerCase() !== normalizedId).slice(0, 2);
        }
      });
    });
  }

  // Conteúdo principal
  let textContent = currentTopic
    ? (currentTopic.content || currentTopic.title)
    : 'Conteúdo não encontrado.';

  // ===================== LEITURA POR VOZ =====================
  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();
      setVoices(availableVoices);
    };

    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  const toggleVoiceReading = () => {
    if (isReading) {
      window.speechSynthesis.cancel();
      setIsReading(false);
    } else {
      const utterance = new SpeechSynthesisUtterance(textContent);
      utterance.lang = voiceLang;
      utterance.rate = voiceSpeed;

      const genderKeyword = voiceGender === 'female' ? 'female' : 'male';
      let selectedVoice = voices.find((voice) => 
        voice.lang === voiceLang && voice.name.toLowerCase().includes(genderKeyword)
      );
      if (!selectedVoice) {
        selectedVoice = voices.find((voice) => voice.lang === voiceLang);
      }
      if (selectedVoice) {
        utterance.voice = selectedVoice;
      }

      window.speechSynthesis.speak(utterance);
      setIsReading(true);

      utterance.onend = () => setIsReading(false);
    }
  };

  // ===================== LEITURA BIÓNICA =====================
  const applyBionicReading = (text) => {
    if (!isBionic) return text;
    return text.split(' ').map((word, index) => {
      const midPoint = Math.ceil(word.length / 2);
      return (
        <span key={index}>
          <b>{word.slice(0, midPoint)}</b>
          {word.slice(midPoint)}{' '}
        </span>
      );
    });
  };

  return (
    <div className="read-page-container">
      <div className="header-image">
        <img src={classroomImage} alt="Classroom" />
      </div>

      {/* ======= Controles ======= */}
      <div className="controls">
        <div className="font-size-controls">
          <button onClick={() => setFontSize((s) => Math.min(s + 2, 32))} className="control-btn">
            Aumentar
          </button>
          <button onClick={() => setFontSize((s) => Math.max(s - 2, 12))} className="control-btn">
            Diminuir
          </button>
        </div>
        <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
          {isBionic ? 'Desativar Biónico' : 'Ativar Biónico'}
        </button>
        <div className="voice-controls">
          <button onClick={toggleVoiceReading} className="control-btn">
            {isReading ? 'Parar Voz' : 'Ler por Voz'}
          </button>
          <div className="voice-options">
            <select value={voiceSpeed} onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}>
              <option value={0.5}>Lento</option>
              <option value={1}>Normal</option>
              <option value={1.5}>Rápido</option>
            </select>
            <select value={voiceGender} onChange={(e) => setVoiceGender(e.target.value)}>
              <option value="female">Feminina</option>
              <option value="male">Masculina</option>
            </select>
            <select value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)}>
              <option value="pt-BR">Português</option>
              <option value="en-US">Inglês</option>
            </select>
          </div>
        </div>
      </div>

      {/* ======= Conteúdo ======= */}
      <div className="content">
        <h1>
          {currentTopic?.title ||
            (normalizedId ? normalizedId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo')}
        </h1>

        <p style={{ fontSize: `${fontSize}px` }} className="main-text">
          {applyBionicReading(textContent)}
        </p>

        <div className="author">
          <span>
            Disciplina: {currentSubject || 'N/A'} | Classe: {currentClass || 'N/A'}
          </span>
        </div>
      </div>

      {/* ======= Relacionados ======= */}
      <div className="related-blogs">
        <h2>Temas Relacionados</h2>
        <div className="blog-posts">
          {relatedTopics.length > 0 ? (
            relatedTopics.map((topic) => (
              <Link key={topic.id} to={`/read/${topic.id}`} className="blog-post">
                <h3>{topic.title}</h3>
                <p>Data: {topic.date}</p>
                <span className="read-more">Ler Mais</span>
              </Link>
            ))
          ) : (
            <p>Nenhum tema relacionado disponível.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadPage;